// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function WrappedSectionHeader(Props) {
  var title = Props.title;
  return React.createElement("h4", {
              className: "font-semibold text-2xl pb-4 font-montserrat text-secondary-11"
            }, title);
}

var make = WrappedSectionHeader;

export {
  make ,
  
}
/* react Not a pure module */
